import { IAppState } from '../../../AppModulesWrapper';
import { IServicePeriod } from '../../types/reducers/publishTerms';

export function selectPublicationPeriod(state: IAppState): IServicePeriod | null {
  return state.servicePickerWidget.publishTerms.publication.period;
}
